import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { RESOURCES, DEFAULT_LANG, SUPPORTED_LANGS } from "./config";
import { resolveLanguage, cacheLanguage } from "./languageUtils";

const detectedLang = resolveLanguage();

// Cache it
cacheLanguage(detectedLang);

i18n.use(initReactI18next).init({
  resources: RESOURCES,
  lng: detectedLang,
  fallbackLng: DEFAULT_LANG,
  supportedLngs: SUPPORTED_LANGS,
  load: "languageOnly",
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
  debug: false,
});

export default i18n;
